import React, { useEffect, useRef } from 'react'
import CapitalCarrierService from './CapitalCarrierService';
import CapitalDansSection from './CapitalDansSection';
import Navbar from '../CommanPage/Navbar';
import Footer from '../CommanPage/Footer';
import CapitalCarrierSlider from './CapitalCarrierSlider';
const CapitalCarrierPage = () => {
  const ServicerRef = useRef(null);
  const footerRef = useRef(null);
  
  const handleLinkClick = () => {
    if (footerRef.current) {
      footerRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  

  const serviceClick  = () =>{
        if (ServicerRef.current) {
          ServicerRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      }
      useEffect(() => { 
        window.scrollTo(0,0);
      }, []);
      
  return (
    <>
      <Navbar handleLinkClick={handleLinkClick} />
      <CapitalCarrierSlider serviceClick={serviceClick}/>
      <CapitalDansSection />
      <div ref={ServicerRef}>
      <CapitalCarrierService />
      </div>
      <div ref={footerRef}>
      <Footer />
      </div>
    </>
  )
}

export default CapitalCarrierPage
